module.exports = __webpack_public_path__ + "img/settings/CDN77.b74e73.svg";